<template>
    <router-view />
</template>
<script>
import { defineComponent } from 'vue';
import providersService from 'src/services/providers.service';
// import { queryBot } from 'boot/axios';

const CHECK_UPDATE_INTERVAL = 10 * 60 * 1000; // проверяем обновление 1 раз в 10 минут

export default defineComponent({
    name: 'App',
    data () {
        return {
            timer: undefined,
        };
    },
    created () {
        this.$q.cache = {};
        this.$q.allowRefresh = true;
        this.timer = setInterval(this.checkAppUpdate, CHECK_UPDATE_INTERVAL);
        providersService.init();
    },
    unmounted () {
        clearInterval(this.timer);
    },
    methods: {
        async checkAppUpdate () {
            /*
            if (!this.$q.allowRefresh) {
                return;
            }
            await queryBot('select value from meta where param = \'app-ver\'').then((r) => {
                const { data } = r;
                const [row] = data;
                if (row) {
                    const { value } = row;
                    const lastUpdatedAt = localStorage.getItem('last-app-update');
                    if (lastUpdatedAt !== value) {
                        localStorage.setItem('last-app-update', value);
                        window.location.reload();
                    }
                }
            });
            */
        },
    },
});
</script>
